module.exports = __webpack_public_path__ + "img/lpo.f28c73a4.jpg";